import { useDisclosure } from "@chakra-ui/react";
import { AiOutlineHeart } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import {
  likeEvent,
  fetchAllEvents,
  viewSinglePost,
  closeSinglePost,
} from "../../../redux/posts/posts.action";
import { emotionsIcons, selectEmoticons } from "../../../constants/data";
import { motion } from "framer-motion";
import { FaRegComment } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { RiShareForwardFill } from "react-icons/ri";
import SharePost from "../../Upload/SharePost";
import ModalComponent from "../../Modal/Modal";
import likeIcon from "../../../assets/images/like.png";
import { MapContext } from "../../../context/MapContext";
import { getGoogleLocation } from "../../../utils/utils";
import CommunityPostModal from "../../Community/ViewCommunityPostModal";
import SingleUserPost from "../SingleUserPost";

function CommunityPostShare({
  index,
  theme,
  selectedPost,
  getData,
  reportPost,
  selectedPost: { id, likedBy, likeCount, commentCount, title },
}) {
  const darktheme = useSelector((state) => state.features.settings.darktheme);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [like, setLike] = useState(false);
  const [emotions, setEmoticons] = useState("");
  const [liked, setLiked] = useState(false);
  const [likes, setLikes] = useState(0);
  const dispatch = useDispatch();
  const [emoticon, setEmoticon] = useState("");
  const navigate = useNavigate();
  const token = useSelector((state) => state.auth.accessToken);
  const { user } = useSelector((state) => state.auth);
  const [, setShowModal] = useState(false);
  const [, setSuspended] = useState(false);
  const { mapRef } = useContext(MapContext);
  const [location, setLocation] = useState({
    longitude: 0,
    latitude: 0,
  });
  const { modalActive, modalId } = useSelector((state) => state.posts);
  const [selectedId, setSelectedId] = useState(null);
  const selectPost = (item) => {
    setSelectedId(item);
    handleSinglePostModal(item);
  };

  const handleSinglePostModal = (item) => {
    if (token && selectedId) {
      if (user.suspend) {
        setSuspended(true);
      } else {
        if (selectedId?.media?.images?.length === 0) {
          dispatch(
            viewSinglePost({
              postId: selectedId?.id,
              modalId: 100,
              modalActive: isOpen,
            })
          );
        } else {
          dispatch(
            viewSinglePost({
              postId: selectedId?.id,
              modalId: 101,
              modalActive: isOpen,
            })
          );
        }

        mapRef?.current?.flyTo({
          center: [selectedId?.coords.longitude, selectedId?.coords.latitude],
          zoom: 15,
          speed: 0.8,
          essential: true,
        });
        dispatch(fetchAllEvents(true));
      }
    } else {
      setShowModal(true);
    }
  };

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const { lat, lng } = await getGoogleLocation();
        setLocation({
          latitude: lat,
          longitude: lng,
        });
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    };

    fetchLocation();
    // eslint-disable-next-line
  }, []);

  const postLike = (item) => {
    setLike(!like);
    let payload = { reactionType: item };

    dispatch(likeEvent(id, payload))
      .then((data) => {
        const likeStatus = getLiked(data.data.likedBy);
        if (likes >= 0) {
          if (likeStatus) {
            getEmoticons(data.data.likedBy);
            setLikes(data.data.likeCount);
          } else {
            if (likes >= 1) setLikes(data.data.likeCount);
            setEmoticons("");
          }
        }
      })
      .catch((err) => {});
  };

  const getLiked = (data) => {
    if (data && data.length === 0) return false;
    else if (data && data.find((item) => item.user === user.username))
      return true;
  };

  const getEmoticons = (data) => {
    // eslint-disable-next-line
    data?.map((each) => {
      if (each?.user === user?.username) {
        setEmoticons(each?.reaction);
      }
    });
  };

  const clickIcon = (item, e) => {
    if (token) {
      e.stopPropagation();
      setEmoticon(item);
      postLike(item);
      setLike(!like);
    } else {
      navigate("/login");
    }
  };

  const ownership = () => {
    if (likedBy && likedBy?.length === 0) setEmoticons("");
    else if (
      likedBy !== undefined &&
      likedBy?.find((item) => item.user === user?.username)
    ) {
      // eslint-disable-next-line
      likedBy?.map((each) => {
        if (each.user === user?.username) {
          setEmoticons(each.reaction);
          setLiked(true);
        }
      });
    } else setEmoticons("");
  };

  useEffect(() => {
    ownership();
    // eslint-disable-next-line
  }, [likedBy]);

  useEffect(() => {
    setLikes(likeCount);
    // eslint-disable-next-line
  }, [likedBy]);

  const closeSinglePostModal = () => {
    dispatch(closeSinglePost());
  };
  return (
    <div key={index} className=" ">
      <div className="text-[#60646C] h-[20px] font-inter font-[400]  flex w-full justify-between text-[13px] text-[#60646c] my-[.6rem]">
        <div className="flex items-center align-center h-full gap-[4px] ">
          <img src={likeIcon} alt="" className="w-4 h-4" />
          <p className="text-[13px]  mt-1  font-inter font-[400]">
            {likes} Reaction{" "}
          </p>
        </div>
        <p className="text-[13px]  font-inter font-[400]">
          {" "}
          {commentCount} Comments
        </p>
      </div>
      <div className="flex justify-between border-t border-1 py-[1rem]">
        <div className="flex  group relative items-center cursor-pointer ">
          <button
            className={`invisible group-hover:visible
            absolute h-[50px] left-0 bottom-5 pb-2 
            ml-0 flex justify-around  items-center  text-[#60646c] rounded-[15px] cursor-pointer w-[200px] ${
              theme ? "bg-kdark3 text-white" : "bg-[#fff] text-[#60646c]"
            }  `}
          >
            {emotionsIcons?.map((item, i) => (
              <motion.img
                initial={{ x: -100 }}
                animate={{ x: 0 }}
                exit={{ x: -100 }}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                src={item?.icon}
                alt={item?.name}
                key={i}
                className="object-contain w-[13%]"
                onClick={(e) => clickIcon(item?.name, e)}
              />
            ))}
          </button>
          {like ? (
            selectEmoticons(emoticon)
          ) : liked ? (
            <span className="mr-1" onClick={(e) => clickIcon("", e)}>
              {selectEmoticons(emotions)}
            </span>
          ) : (
            <AiOutlineHeart
              className="flex items-center mr-1 text-[#1A202C]"
              size={20}
              // onClick={(e) => clickIcon("love", e)}
            />
          )}{" "}
          Like
        </div>

        <button
          onClick={() => selectPost(selectedPost)}
          className="flex items-center text-[#60646c]"
        >
          <FaRegComment className=" mr-1 text-[#1A202C]" size={24} /> Comment
        </button>
        <button className="flex items-center text-[#60646c]" onClick={onOpen}>
          <RiShareForwardFill className="mr-1 text-[#1A202C]" size={24} /> Share{" "}
          {selectedPost?.sharedCount}
        </button>
      </div>
      {modalActive &&
        token &&
        (selectedId?.media?.images?.length === 0 ||
        !selectedId?.media?.images ? (
          <CommunityPostModal
            // openReportModal={reportPost}
            updateCounts={getData}
            theme={darktheme}
            id={selectedId?.id}
            isOpen={
              modalActive &&
              modalId === 100 &&
              selectedId?.media?.images?.length === 0
            }
            coords={location}
            onClose={closeSinglePostModal}
          />
        ) : (
          <SingleUserPost
            openReportModal={reportPost}
            updateCounts={getData}
            theme={darktheme}
            id={selectedId?.id}
            isOpen={
              modalActive &&
              modalId === 101 &&
              selectedId?.media?.images?.length > 0
            }
            onClose={closeSinglePostModal}
            coords={location}
          />
        ))}

      {
        <ModalComponent
          isOpen={isOpen}
          onClose={onClose}
          className="rounded-2xl"
          size={"sm"}
        >
          <SharePost theme={theme} id={id} title={title} />
        </ModalComponent>
      }
    </div>
  );
}

export default CommunityPostShare;
